export const resolveEmbedClasses = (element) => {
  const options = element.options;
  let classes = "element-content cf-embed-outer ";
  let alignmentClass = "cf-outer-center";

  if (options["cf-alignment"]) {
    if (options["cf-alignment"].indexOf("left") > -1) {
      alignmentClass = "cf-outer-left";
    } else if (options["cf-alignment"].indexOf("center") > -1) {
      alignmentClass = "cf-outer-center";
    } else if (options["cf-alignment"].indexOf("right") > -1) {
      alignmentClass = "cf-outer-right";
    }
  }

  classes += " " + alignmentClass;

  if (!options["embed-cta-id"]) {
    classes += " cf-embed-missing";
  }

  return classes;
};

export const buildEmbedStylesheet = (builder, device, cta, element) => {
  let options = { ...element.options };

  let boxShadow;

  if (options["box-shadow"] == "soft") {
    boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
  }

  if (options["box-shadow"] == "hard") {
    boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
  }

  if (options["box-shadow"] == "custom") {
    boxShadow = "";
    boxShadow +=
      (options["box-shadow-horizontal-distance"]
        ? `${options["box-shadow-horizontal-distance"]}px`
        : "0px") + " ";

    boxShadow +=
      (options["box-shadow-vertical-distance"]
        ? `${options["box-shadow-vertical-distance"]}px`
        : "0px") + " ";

    boxShadow +=
      (options["box-shadow-blur-radius"]
        ? `${options["box-shadow-blur-radius"]}px`
        : "0px") + " ";

    boxShadow +=
      (options["box-shadow-spread-radius"]
        ? `${options["box-shadow-spread-radius"]}px`
        : "0px") + " ";

    boxShadow +=
      (options["box-shadow-color"]
        ? options["box-shadow-color"]
        : "rgba(0,0,0, 0.35)") + " ";
  }

  let mobileAlignmentMargin = '';
  if (options["cf-alignment-mobile"]) {
    if (options["cf-alignment-mobile"].indexOf("left") > -1) {
      mobileAlignmentMargin = 'margin-left: 0px !important; margin-right: auto !important;';
    } else if (options["cf-alignment-mobile"].indexOf("center") > -1) {
      mobileAlignmentMargin = 'margin-left: auto !important; margin-right: auto !important;';
    } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
      mobileAlignmentMargin = 'margin-left: auto !important; margin-right: 0px !important;';
    }
  }

  let mobileMaxWidth = '';
  if (options["embed-width-mobile"] == 'custom' && options["embed-width-value-mobile"]) {
    mobileMaxWidth = 'max-width: ' + options["embed-width-value-mobile"] + 'px !important;';
  } else if (options["embed-width-mobile"] && options["embed-width-mobile"] !== 'custom') {
    mobileMaxWidth = 'max-width: none !important;';
  }

  // prettier-ignore
  const desktopStyles =
`#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-embed-outer {
  ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
  ${options["embed-width"] == 'custom' && options["embed-width-value"] ? 'max-width: ' + options["embed-width-value"] + 'px !important;' : ''}
}
`;

  // prettier-ignore
  const mobileStyles =
`/* mobile styles */
#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-embed-outer {
    ${mobileMaxWidth}
    ${mobileAlignmentMargin}
}
`;

  if (builder !== true) {
    return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
  } else {
    if (device == "desktop") {
      return desktopStyles;
    } else {
      return desktopStyles + mobileStyles;
    }
  }
};
